
<template>
  <div class="main-container">
    <div class="title-container">
      <div class="title">
        <span class="title-text">行程方案生成</span>
      </div>
      <div class="page-remark">
        <span class="remark-text"
          >通过 PNR 内容、QTE 内容、XS FSB(行李)、XS FSG(<font color="#FF0000"
            >中文退改</font
          >)内容生成行程方案，请看<router-link
            target="_blank"
            :to="{ path: '/videogds' }"
            >操作视频</router-link
          >；多条退改规则，请先选择最严格的规则生成报价方案；如果 QTE
          内容中存在行李重量，而非行李件数，可不提供 XS FSB 信息。 <br /><font
            color="#FF0000"
            >支持携程预订</font
          >生成行程方案，请看<router-link
            target="_blank"
            :to="{ path: '/video' }"
            >操作视频</router-link
          >
        </span>
      </div>
    </div>
    <div class="main-content">
      <el-row class="content-row" :gutter="24">
        <el-col :span="24"
          ><el-button type="primary" plain :icon="HelpFilled" @click="translate"
            >生成方案</el-button
          ></el-col
        >
      </el-row>
      <el-row class="content-row" :gutter="24">
        <el-col :span="12"
          ><label class="remark-text" for="pnr">编码内容：</label></el-col
        >
        <el-col :span="12"
          ><label class="remark-text" for="pnr">行程方案：</label></el-col
        >
      </el-row>
      <el-row :gutter="24"
        ><el-col :span="12">
          <el-form :model="solution" ref="solutionForm">
            <el-row
              ><el-col :span="24">
                <el-form-item>
                  <el-input
                    type="textarea"
                    :rows="20"
                    id="pnr"
                    v-model="solution.pnrContent"
                  ></el-input></el-form-item></el-col
              ><el-col :span="12"><span></span></el-col>
            </el-row>
            <el-row
              ><el-col :span="24">
                <el-form-item label="方案说明">
                  <el-input
                    v-model="solution.remark"
                  ></el-input></el-form-item></el-col
              ><el-col :span="12"><span></span></el-col>
            </el-row>
            <el-row
              ><table width="100%">
                <tr>
                  <td class="td-title table-first-col"></td>
                  <td class="td-title">
                    <span class="table-title">总价/人</span>
                  </td>
                  <td class="td-title">
                    <span class="table-title">加价金额/人</span>
                  </td>
                  <td class="td-title">
                    <span class="table-title">加价比例/人</span>
                  </td>
                </tr>
                <tr>
                  <td class="td-title table-first-col">
                    <span class="table-title">票价</span>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.totalTicket"
                      class="input-content"
                    ></el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addMoneyTicket"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addPercentTicket"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td class="td-title table-first-col">
                    <span class="table-title">退票</span>
                  </td>
                  <td>
                    <el-input
                      placeholder="复杂金额，不能直接指定价格"
                      disabled="true"
                    >
                    </el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addMoneyRefund"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addPercentRefund"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <td class="td-title table-first-col">
                    <span class="table-title">改签</span>
                  </td>
                  <td>
                    <el-input
                      placeholder="复杂金额，不能直接指定价格"
                      disabled="true"
                    >
                    </el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addMoneyChange"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                  <td>
                    <el-input
                      v-model.number="solution.addPercentChange"
                      class="input-content"
                    >
                    </el-input>
                  </td>
                </tr></table></el-row></el-form></el-col
        ><el-col :span="12">
          <el-input
            type="textarea"
            :rows="32"
            v-model="result"
            id="pnr"
          ></el-input></el-col
      ></el-row>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "@vue/composition-api";
import { reactive, getCurrentInstance, ref, watch } from "vue";
import { HelpFilled } from "@element-plus/icons-vue";

export default defineComponent({
  emits: ["login"],
  setup(props, context) {
    console.log(props);
    let { proxy } = getCurrentInstance();
    const dialogLoginVisible = ref(false);
    let result = ref(String);
    result.value = "";

    let solution = reactive({
      pnrContent: "",
      remark: "",
      totalTicket: 0,
      addMoneyTicket: 0,
      addPercentTicket: 0,
      addMoneyRefund: 0,
      addPercentRefund: 0,
      addMoneyChange: 0,
      addPercentChange: 0,
      test: "wanghuixiong",
    });

    function login(show) {
      dialogLoginVisible.value = show;
    }

    /**
     * 转换方案
     */
    function translate() {
      if (solution.pnrContent === "") {
        return;
      }
      // console.log(solution);
      proxy.$http.post("/solution/translate", solution).then((Response) => {
        console.log(Response);
        if (Response === "FORBIDDEN") {
          // console.log("true");
          // console.log(dialogLoginVisible.value);
          // dialogLoginVisible.value = true;
          context.emit("login");
          return;
        }
        result.value = Response;
      });
    }

    function openVideo() {
      this.$router.push("/video");
    }

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyTicket,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addPercentTicket = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentTicket,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addMoneyTicket = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyRefund,
      (newVal) => {
        solution.addMoneyChange = newVal;
        if (newVal === 0) {
          return;
        }
        solution.addPercentRefund = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentRefund,
      (newVal) => {
        solution.addPercentChange = newVal;
        if (newVal === 0) {
          return;
        }
        solution.addMoneyRefund = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addMoneyChange,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addPercentChange = 0;
      }
    );

    /**
     * 加价金额和加价比例只有一个生效，最后输入的生成
     */
    watch(
      () => solution.addPercentChange,
      (newVal) => {
        if (newVal === 0) {
          return;
        }
        solution.addMoneyChange = 0;
      }
    );

    return {
      solution,
      translate,
      result,
      openVideo,
      dialogLoginVisible,
      login,
      HelpFilled,
    };
  },
});
</script>
<style lang="scss" scoped>
.main-container {
  margin: -24px -24px 0 -24px;
}
.title-container {
  padding: 12px 24px 16px 24px;
  background-color: #fff;
}
.title {
  height: 40px;
  padding: 8px 0px 0px 0px;
}
.title-text {
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
}
.page-remark {
  padding: 12px, 0px, 0px, 0px;
}
.remark-text {
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.main-content {
  margin: 24px;
  padding: 24px;
  background-color: #fff;
}
.content-row {
  margin-bottom: 16px;
}
table,
th,
td {
  widows: 100%;
  border-collapse: collapse;
  border-color: #d3dce6;
  border-width: 1px;
  border-style: solid;
  height: 36px;
}
.price-table-col {
  border-color: #d3dce6;
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  height: 36px;
  padding: 0px 2px;
}
.td-title {
  background-color: #fafafa;
}
.table-title {
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 14px;
  padding: 4px;
}
.table-first-col {
  min-width: 40px;
}

// /deep/.el-input__inner {
//   text-align: right;
// }
</style>
